import {
  Card,
  CardBody,
  Stat,
  StatGroup,
  StatLabel,
  StatNumber,
} from "@chakra-ui/react";
import { useFundFamilyCommitmentStatsRetrieveSuspense } from "gen/endpoints/commitment-stats/commitment-stats";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  CardSection,
  CardSectionBody,
  CardSectionGroup,
  CardSectionTitle,
} from "shared/components/card/CardSection";
import { formatMoney } from "shared/utils/MoneyUtils";

export interface CommitmentsStatsProps {
  fundFamilyId: string;
}

export const CommitmentsStats: React.FC<CommitmentsStatsProps> = ({
  fundFamilyId,
}) => {
  const { t } = useTranslation(["commitment", "investorTransfer", "common"]);

  const { data: commitmentStats } =
    useFundFamilyCommitmentStatsRetrieveSuspense(fundFamilyId);

  if (commitmentStats.commitments_by_fund.length === 1) {
    return (
      <Card variant="stat" size="xs" borderRadius="8px" mb="24px">
        <CardBody>
          <StatGroup>
            <Stat variant="horizontal">
              <StatLabel pr="4px">
                {t("commitment:totalAmountCommittedInline")}
              </StatLabel>
              <StatNumber
                sx={{
                  textStyle: "h6",
                }}
              >
                {formatMoney(commitmentStats.total_commitment_amount)}
              </StatNumber>
            </Stat>
          </StatGroup>
        </CardBody>
      </Card>
    );
  }

  return (
    <Card variant="stat" mb="24px">
      <CardBody>
        <CardSectionGroup>
          <CardSection>
            <CardSectionTitle>{t("common:fundFamily")}</CardSectionTitle>
            <CardSectionBody>
              <StatGroup>
                <Stat size="xs">
                  <StatNumber>
                    {formatMoney(commitmentStats.total_commitment_amount)}
                  </StatNumber>
                  <StatLabel>{t("commitment:totalAmountCommitted")}</StatLabel>
                </Stat>
              </StatGroup>
            </CardSectionBody>
          </CardSection>
          <CardSection>
            <CardSectionTitle>{t("commitment:fundBreakdown")}</CardSectionTitle>
            <CardSectionBody>
              <StatGroup>
                {commitmentStats.commitments_by_fund.map((c) => (
                  <Stat key={c.fund_id} size="xs">
                    <StatNumber>
                      {formatMoney(c.total_commitment_amount)}
                    </StatNumber>
                    <StatLabel>{c.fund_legal_name}</StatLabel>
                  </Stat>
                ))}
              </StatGroup>
            </CardSectionBody>
          </CardSection>
        </CardSectionGroup>
      </CardBody>
    </Card>
  );
};
